import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-facet-filter-search',
  templateUrl: './facet-filter-search.component.html',
  styleUrls: ['./facet-filter-search.component.scss']
})
export class FacetFilterSearchComponent {
  @Input() facetCategorySearch = {};
  @Input() loading: boolean;
  @Input() panel;
  @Input() activePanel = "";
  @Input() refreshCurrentPanel = false;
  @Input() placeholderValues = {};
  @Output() onKeyUp: EventEmitter<any> = new EventEmitter();

  onFacetCategorySearch(evt) {
    this.onKeyUp.emit(evt);
  }
}
